/**
 * Mobile long-press wrapper for calendar event chips. On touch devices a long
 * press (400ms) fires the supplied handler with a light haptic. Extracted
 * verbatim from EventListModule's module-top components — it holds no
 * component-state closure, so it is safe to relocate and share across views.
 */
import React from 'react';
import { useLongPress } from '@/common/hooks/useLongPress';
import { hapticLight } from '@/lib/capacitor';

export function MobileLongPressEvent({
  children,
  onLongPress,
  className,
  style,
  eventId,
}: {
  children: React.ReactNode;
  onLongPress: () => void;
  className?: string;
  style?: React.CSSProperties;
  /** Mirrors the desktop branch's data-event-id so cross-module deep-links
   *  (e.g. the Daily Brief) can locate and flash the event on touch layouts. */
  eventId?: string;
}) {
  const handlers = useLongPress({
    onLongPress: () => {
      hapticLight();
      onLongPress();
    },
    delay: 400,
  });

  return (
    <div className={className} style={style} data-event-id={eventId} {...handlers}>
      {children}
    </div>
  );
}
